import {createPunch$, deletePunch$, getPunches$, updatePunch$} from "../services/projects";
import {networkError} from "./ui";
import {extractSubview} from "./view";

export const ADD_PUNCH_LIST_ITEMS = 'ADD_PUNCH_LIST_ITEMS';
export const addPunchLists = (list) => ({type: ADD_PUNCH_LIST_ITEMS, payload: list});
export const API_GET_PUNCH_LISTS = 'API_GET_PUNCH_LISTS';
export const getPunchLists = (projectId, offset) => ({type: API_GET_PUNCH_LISTS, payload: {projectId, offset}});
export const API_GET_PUNCH_LISTS_DONE = 'API_GET_PUNCH_LISTS_DONE';
export const getPunchListsDone = (response) => ({type: API_GET_PUNCH_LISTS_DONE, payload: response});
export const API_GET_PUNCH_LIST = 'API_GET_PUNCH_LIST';
export const getPunchList = (projectId, id) => ({type: API_GET_PUNCH_LIST, payload: {projectId, id}});
export const API_GET_PUNCH_LIST_DONE = 'API_GET_PUNCH_LIST_DONE';
export const getPunchListDone = (response, callback) => ({ type: API_GET_PUNCH_LIST_DONE, payload: { response, callback } });

export const createPunch = (projectId, punchList, callback) => async (dispatch, getState) => {
  try {
    let { response, status } = await createPunch$({ projectId, document: punchList }).toPromise();
    ({ response, status } = await getPunches$({ id: response, projectId }).toPromise());
    dispatch(getPunchListDone(response, callback));
  } catch (error) {
    dispatch(networkError({...error, number: '10137-'+error.status}));
  }
};

export const deletePunch = (projectId, punchListId) => async (dispatch, getState) => {
  try {
    let { response, status } = await deletePunch$({ projectId, subId: punchListId }).toPromise();
    dispatch(extractSubview([punchListId]));
  } catch (error) {
    dispatch(networkError({...error, number: '10138-'+error.status}));
  }
};

export const updatePunch = (projectId, punchList) => async (dispatch, getState) => {
  try {
    let punchListId = punchList.id;
    let { response, status } = await updatePunch$({ projectId, subId: punchListId, document: punchList }).toPromise();
    let { response: response2, status: status2 } = await getPunches$({ projectId, id: punchListId }).toPromise();
    dispatch(getPunchListDone(response2));
  } catch (error) {
    dispatch(networkError({...error, number: '10139-'+error.status}));
  }
};



// WEBPACK FOOTER //
// ./src/actions/punchList.js